import { useState, ImgHTMLAttributes, useEffect } from 'react';
import cx from 'classnames';
import Image from 'next/image';
import Spinner from 'components/Spinner/Spinner';
import { imageLoader } from 'functions/imageLoader';
import React from 'react';

interface LoadingImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  sizes?: string;
  style?: any;
  quality?: number;
  className?: any;
  priority?: boolean;
}

const LoadingImage: React.FC<LoadingImageProps> = ({ src, alt, sizes, quality, style, className, priority}) => {
  const [loading, setLoading] = useState(true);

 // console.log('src', src);
  return (
    <>
      {loading && (
        <div className="mr-2 flex justify-center items-center pt-[1px] h-full w-full">
          <Spinner fill="grey" />
        </div>
      )}
      {priority && (<Image
        quality={quality??80}
        key={src}
        className={cx(`transition-opacity opacity-0 duration-[0.5s]`, className)}
        fill
        style={style}
        onLoadingComplete={(image) => {
          image.classList.remove("opacity-0");
        }}
        sizes={sizes}
        loader={imageLoader}
        src={src}
        onLoad={() => setLoading(false)}
        alt={alt}
        //add priority attribute only if isPriority is true if not priority should not exist 
        priority
        onError={(ev) => ev.currentTarget.src = 'https://cdn.dresden.vision/images/noimage.png'}
      />)}
      {!priority && (<Image
        quality={quality??80}
        key={src}
        className={cx(`transition-opacity opacity-0 duration-[0.5s]`, className)}
        fill
        style={style}
        onLoadingComplete={(image) => {
          image.classList.remove("opacity-0");
        }}
        sizes={sizes}
        loader={imageLoader}
        src={src}
        onLoad={() => setLoading(false)}
        alt={alt}
        //add priority attribute only if isPriority is true if not priority should not exist 
        onError={(ev) => ev.currentTarget.src = 'https://cdn.dresden.vision/images/noimage.png'}
      />)}
    </>
  );
};
export default React.memo(LoadingImage);